import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './met-service.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const MetServiceDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const metServiceEntity = useAppSelector(state => state.metService.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="metServiceDetailsHeading">
          <Translate contentKey="almobadaraMasterDataApp.metService.detail.title">MetService</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{metServiceEntity.id}</dd>
          <dt>
            <span id="code">
              <Translate contentKey="almobadaraMasterDataApp.metService.code">Code</Translate>
            </span>
          </dt>
          <dd>{metServiceEntity.code}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="almobadaraMasterDataApp.metService.name">Name</Translate>
            </span>
          </dt>
          <dd>{metServiceEntity.name}</dd>
          <dt>
            <span id="nameAr">
              <Translate contentKey="almobadaraMasterDataApp.metService.nameAr">nameAr</Translate>
            </span>
          </dt>
          <dd>{metServiceEntity.nameAr}</dd>
          <dt>
            <span id="nameEn">
              <Translate contentKey="almobadaraMasterDataApp.metService.nameEn">nameEn</Translate>
            </span>
          </dt>
          <dd>{metServiceEntity.nameEn}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="almobadaraMasterDataApp.metService.status">Status</Translate>
            </span>
          </dt>
          <dd>{metServiceEntity.status}</dd>
          <dt>
            <Translate contentKey="almobadaraMasterDataApp.metService.category">Category</Translate>
          </dt>
          <dd>{metServiceEntity.category ? metServiceEntity.category.name : ''}</dd>
        </dl>
        <Button tag={Link} to="/met-service" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/met-service/${metServiceEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default MetServiceDetail;
